import { Satellite } from "lucide-react";
import ViewMgtDevicePanel from "../ViewMgtDevicePanel";
import { ViewMgtDeviceStatusValue } from "./ViewMgtDeviceStatusValue";

export default function ViewMgtDeviceStatusSatellites({ device }: { deviceId?: string | null | undefined, device?: any | undefined | null }) {
  return (
    <ViewMgtDevicePanel title="Satellites" icon={<Satellite size={16} />}>
      <div className="grid grid-cols-1 gap-0">

        <ViewMgtDeviceStatusValue 
          label="Count"
          value={device?.LastLocation?.noSatellites?.toString()}
          color="text-slate-500"
          timestamp={device?.LastLocation?.updatedAt}
        />

        <ViewMgtDeviceStatusValue 
          label="DOP"
          value={device?.LastLocation?.dop?.toString()}
          color="text-slate-500"
          timestamp={device?.LastLocation?.updatedAt}
        />

      </div>
    </ViewMgtDevicePanel>
  );
}
